<template>
  <div
    v-if="filter !== null"
    class="d-flex flex-row flex-wrap flex-gap-8"
  >
    <v-autocomplete
      v-show="hardcodedAttribute === null"
      outlined
      dense
      hide-details
      :label="$t(langPath + 'chooseAttr')"
      :value="attr"
      :items="items"
      @input="propertyChanged"
    />
    <slot name="operator" />
    <template v-if="Array.isArray(possibleValues[attr].values)">
      <v-autocomplete
        v-model="
          /* eslint-disable-next-line vue/no-mutating-props */
          filter[operator][attr][0]
        "
        outlined
        dense
        hide-details
        :items="possibleValues[attr].values || []"
      />
      <v-autocomplete
        v-model="
          /* eslint-disable-next-line vue/no-mutating-props */
          filter[operator][attr][1]
        "
        outlined
        dense
        hide-details
        :items="possibleValues[attr].values || []"
      />
    </template>
    <template v-else-if="possibleValues[attr].type === APIFilterDataType.DATE">
      <FormDateTimePicker
        v-model="
          /* eslint-disable-next-line vue/no-mutating-props */
          filter[operator][attr][0]
        "
        single
      />
      <FormDateTimePicker
        v-model="
          /* eslint-disable-next-line vue/no-mutating-props */
          filter[operator][attr][1]
        "
        single
      />
    </template>
    <template v-else>
      <v-text-field
        v-model="
          /* eslint-disable-next-line vue/no-mutating-props */
          filter[operator][attr][0]
        "
        outlined
        dense
        hide-details
        :rules="[formRules.required]"
        :type="possibleValues[attr].type"
      />
      <v-text-field
        v-model="
          /* eslint-disable-next-line vue/no-mutating-props */
          filter[operator][attr][1]
        "
        outlined
        dense
        hide-details
        :rules="[formRules.required]"
        :type="possibleValues[attr].type"
      />
    </template>
  </div>
</template>

<script>
    import formRules from "@/utils/formRules";
    import {APIFilterMixin} from "@/app/mixins/APIFilterMixin";
    import {APIFilterDataType} from "@/service/APIFilters";
    import FormDateTimePicker from "@/app/components/form/FormDateTimePicker.component";

    export default {
        name: "FilterConfigTernaryOp",
        components: {FormDateTimePicker},
        mixins: [APIFilterMixin],
        data: () => ({
            formRules: formRules,
            APIFilterDataType: APIFilterDataType
        }),
        computed: {
            attr: function () {
                return Object.keys(this.filter[this.operator])[0];
            }
        },
        methods: {
            propertyChanged: function (newValue) {
                const oldValue = this.attr;
                delete this.filter[this.operator][oldValue];
                const possiblePropertyValues = this.possibleValues[newValue].values;
                this.$set(this.filter[this.operator], newValue, [
                    Array.isArray(possiblePropertyValues) ? possiblePropertyValues[0].value : undefined,
                    Array.isArray(possiblePropertyValues) ? possiblePropertyValues[1].value : undefined
                ]);
            }
        }
    };
</script>

<style scoped>

</style>
